<template>
    <div>
        <div class="dropdown flex">
            <div class="flex-1 pr-1">
                <v-select
                    :options="options"
                    label="name"
                    placeholder="Find Person..."
                    v-model="selected"
                    @input="openPerson"
                >
                    <template v-slot:option="option">
                        <div class="py-2 -my-1 border-b border-gray-300">
                            <strong>{{ option.name }}</strong>
                            <div class="text-xs float-right text-gray-750"> {{ option.lastupdate }}</div>
                        </div>
                    </template>
                </v-select>
            </div>
        </div>
    </div>
</template>

<script>
import VueSelect from 'vue-select';

export default {
    components: { VueSelect },

    props: {
        options: '',
    },

    data() {
        return {
            name: '',
            selected: '',
        }
    },

    methods: {
        openPerson() {
            if (this.selected) {
                window.location.href = '/people/' + this.selected.id;
            }
        }
    },
}
</script>
